import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getEmpresa } from '../../../services/empresaService';



export async function gerarDuplicatas(contas) {
   pdfMake.vfs = pdfFonts.pdfMake.vfs;

   console.log(contas);
   
     const empresa = await getEmpresa();

  const duplicatas = [
    {
      empresa: empresa.RAZAO_SOCIAL,
      endereco: empresa.ENDERECO,
      cidade: `${empresa.BAIRRO} - ${empresa.CIDADE} - ${empresa.UF}`,
      cep: empresa.CEP,
      numeroControle: contas.NOSSO_NUMERO,
      cidadeEmissao: `${empresa.CIDADE} - ${empresa.UF}`,
      dataEmissao: contas.DATA_EMISSAO,
      nf: contas.DOCUMENTO,
      valor: contas.TOTAL_PAGAR,
      ordem: contas.DOCUMENTO,
      vencimento: contas.DATA_VENC,
      juros: "",
      multa: "",
      desconto: "",
      descricao: "",
      sacadoCodigo: contas.RESPONSAVEL,
      sacadoNome: contas.RAZAO,
      enderecoSacado: contas.ENDERECO,
      complemento: "",
      cepMunicipio: `${contas.CEP} - ${contas.CIDADE}`,
      cpfCnpj: contas.CNPJ,
      representante: "",
      valorExtenso: contas.VALOR_EXTENSO
    }
  ];

  const content = [];

  duplicatas.forEach((d, index) => {
    content.push(montarDuplicata(d));

    // exatamente 2 por página
    if ((index + 1) % 2 === 0 && index !== duplicatas.length - 1) {
      content.push({ text: "", pageBreak: "after" });
    }
  });

  const docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [10, 10, 10, 10],
    content,
    defaultStyle: {
      fontSize: 9
    }
  };

  pdfMake.createPdf(docDefinition).open();
}

export function montarDuplicata(d) {
  return {
    margin: [0, 0, 0, 20],
    table: {
      widths: ["*"],
      body: [
        [
          {
            stack: [
              cabecalho(d),
              tabelaPrincipal(d),
              dadosSacado(d),
              valorExtenso(d),
              termo(d)
            ]
          }
        ]
      ]
    },
    layout: "noBorders"
  };
}

function cabecalho(d) {
  return {
    table: {
      widths: ["*", 200],
      body: [
        [
          {
            stack: [
              { text: d.empresa, bold: true, fontSize: 12 },
              d.endereco,
              d.cidade,
              d.cep
            ],
            margin: [5, 5, 5, 5]
          },
          {
            stack: [
              { text: "DUPLICATA", bold: true, fontSize: 14, alignment: "right" },
              { text: d.cidadeEmissao, alignment: "right", margin: [0, 15, 0, 0] },
              { text: d.dataEmissao, alignment: "right" }
            ],
            margin: [5, 5, 5, 5]
          }
        ]
      ]
    }
  };
}

function tabelaPrincipal(d) {
  return {
    margin: [0, 5, 0, 0],
    table: {
      widths: [110, 150, 110, 120],
      body: [
        [
          { text: "NF Fatura Nº", bold: true },
          { text: "NF-FAT/Duplicata - Valor", bold: true },
          { text: "Duplicata - Nº ordem", bold: true },
          { text: "Vencimento", bold: true }
        ],
        [
          { text: d.nf, bold: true },
          { text: d.valor, bold: true },
          { text: d.ordem, bold: true },
          { text: d.vencimento, bold: true }
        ],
        [
          {
            colSpan: 4,
            stack: [
              `Juros: ${d.juros}`,
              `Multa: ${d.multa}`,
              `Desconto: ${d.desconto}`,
              `Condições Especiais: ${d.descricao}`
            ],
            margin: [5, 5, 5, 5]
          },
          {},
          {},
          {}
        ]
      ]
    }
  };
}

function dadosSacado(d) {
  return {
    margin: [0, 5, 0, 0],
    table: {
      widths: [160, "*", 90], // ← aumentamos espaço da assinatura emitente
      body: [
        [
          {
            text: "Assinatura do Emitente",
            alignment: "center",
            rotation: 270, // ← aumenta altura
            bold: true
          },
          {
            stack: [
              `Nome Sacado: ${d.sacadoCodigo} - ${d.sacadoNome}`,
              `Endereço: ${d.enderecoSacado}`,
              `Complemento: ${d.complemento}`,
              `CEP/Município: ${d.cepMunicipio}`,
              `CNPJ/CPF: ${d.cpfCnpj}`
            ],
            margin: [5, 10, 5, 10]
          },
          {
            stack: [
              { text: "Rep. M", alignment: "center" },
              { text: d.representante, alignment: "center", margin: [0, 10, 0, 0] }
            ]
          }
        ]
      ]
    }
  };
}

function valorExtenso(d) {
  return {
    margin: [0, 5, 0, 0],
    table: {
      widths: [100, "*"],
      body: [
        [
          { text: "Valor por extenso", bold: true },
          { text: d.valorExtenso, bold: true }
        ]
      ]
    }
  };
}

function termo(d) {
  return {
    margin: [0, 10, 0, 0],
    stack: [
      {
        text:
          "Reconhecemos a exatidão desta DUPLICATA DE VENDA MERCANTIL, na importância acima que pagaremos à " +
          d.empresa +
          " ou à sua ordem, na praça e vencimento indicados.",
        margin: [0, 10, 0, 20]
      },
      {
        columns: [
          {
            text: "Em ____ / ____ / ______",
            margin: [0, 20, 0, 0]
          },
          {
            width: 350,
            stack: [
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 0,
                    x2: 350, // ← tamanho da linha aumentado
                    y2: 0,
                    lineWidth: 1
                  }
                ],
                margin: [0, 30, 0, 5] // ← posição correta acima do texto
              },
              {
                text: "Assinatura Sacado",
                alignment: "center"
              }
            ]
          }
        ]
      }
    ]
  };
}